module.exports = __webpack_public_path__ + "img/icon-options.0005becc.svg";